export default "__VITE_ASSET__BuqV5TxG__"